import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import ExportPanel from "../components/ExportPanel";

function ExportPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: '#F8F9FA' }}>
      {/* Header */}
      <header className="bg-white shadow-sm border-b sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-3">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate("/")}
              title="Geri"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <div>
              <h1 className="text-xl font-bold" style={{ fontFamily: 'Manrope', color: '#1F2937' }}>
                📥 Rapor Dışa Aktarma
              </h1>
              <p className="text-sm text-gray-500">PDF ve CSV Format Desteği</p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <ExportPanel />

          {/* Info Panel */}
          <div className="space-y-6">
            <div className="bg-white rounded-lg shadow p-6">
              <h3 className="text-lg font-semibold mb-4">📊 Rapor Türleri</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <span className="text-2xl">📝</span>
                  <div>
                    <strong className="block">Görev Listesi</strong>
                    <span className="text-sm text-gray-600">Tüm görevlerin detaylı listesi</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl">📊</span>
                  <div>
                    <strong className="block">Proje Özeti</strong>
                    <span className="text-sm text-gray-600">Projelerin genel durumu</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl">💚</span>
                  <div>
                    <strong className="block">Sağlık Raporu</strong>
                    <span className="text-sm text-gray-600">RAG göstergeleri ve metrikler</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl">⏰</span>
                  <div>
                    <strong className="block">Zaman Çizelgesi</strong>
                    <span className="text-sm text-gray-600">Çalışma saatleri raporu</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl">💰</span>
                  <div>
                    <strong className="block">Gider Raporu</strong>
                    <span className="text-sm text-gray-600">Fatura ve maliyet detayları</span>
                  </div>
                </li>
              </ul>
            </div>

            <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
              <h3 className="text-lg font-semibold mb-3 text-blue-900">💡 İpuçları</h3>
              <ul className="space-y-2 text-sm text-blue-800">
                <li className="flex items-start gap-2">
                  <span>•</span>
                  <span>CSV dosyaları Microsoft Excel veya Google Sheets ile açılabilir</span>
                </li>
                <li className="flex items-start gap-2">
                  <span>•</span>
                  <span>PDF dosyaları tüm cihazlarda görüntülenebilir</span>
                </li>
                <li className="flex items-start gap-2">
                  <span>•</span>
                  <span>Tarih aralığı seçerek özel raporlar oluşturabilirsiniz</span>
                </li>
                <li className="flex items-start gap-2">
                  <span>•</span>
                  <span>Hızlı işlemler için hazır tarih preset'lerini kullanın</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ExportPage;
